module.exports = __webpack_public_path__ + "assets/img/portaljuridico.c93aa3cd.png";